/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import moment from 'moment';
import {PageTitle} from '../../../../../../_metronic/layout/core';
import ModeToolbar from '../../../../../modules/ModeToolbar';
import Header from '../../RD/top/Header';
import Footer from '../../RD/top/Footer';
import List from './List';
import PageWrapper from '../../../../../modules/PageWrapper';
import ButtonExel from '../../../../../modules/ButtonExel';

const MIN_DEPOSIT_AMOUNT_FOR_TOP = 500;
const TOP_EXPORT_FIELDS = [
  'place',
  'id',
  'first_name',
  'last_name',
  'workspaces_id',
  'workspaces_name',
  'role_id',
  'role_name',
  'count_qualifications',
  'deposits_count',
  'deposits_amount',
  'players_avg_amount',
  'is_ban',
  'ban_date',
  'is_verified',
  'verify_date',
  'created_at',
  'wallet_created_at',
  'wallet_currency',
  'wallet_details',
  'wallet_id',
  'wallet_type',
];

const getNumberValue = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null && item !== '');
  const number =
    typeof value === 'string'
      ? Number(value.replace(/\s/g, '').replace(/,/g, '').replace(/\$/g, ''))
      : Number(value);

  return Number.isFinite(number) ? number : 0;
};

const getRdStatus = (rdCategories, averageCheck) => {
  const averageCheckValue = getNumberValue(averageCheck);
  const category = rdCategories.find((item) => {
    return (
      averageCheckValue >= getNumberValue(item.rd_min) &&
      averageCheckValue <= getNumberValue(item.rd_max)
    );
  });

  return category?.indicator || 'secondary';
};

const getWorkspaceId = (item) => {
  return (
    item?.workspaces_id ||
    item?.workspace_id ||
    item?.workspace?.id ||
    item?.workspaces?.id ||
    ''
  );
};

const getWorkspaceName = (item) => {
  return (
    item?.workspaces_name ||
    item?.workspace_name ||
    item?.workspace?.name ||
    item?.workspaces?.name ||
    ''
  );
};

const getRoleName = (item) => {
  return item?.role_name || item?.role?.name || '';
};

const formatDateForExport = (date) => {
  if (!date) return '';
  const value = Number(date);
  return Number.isFinite(value) && value > 0
    ? moment.tz(value * 1000, 'Europe/Kyiv').format('DD.MM.YYYY HH:mm ')
    : date;
};

const getExportPlace = (place) => {
  return Number(place) === 99999 ? 0 : place ?? '';
};

const createExportRow = (item) => {
  return {
    place: getExportPlace(item?.place),
    id: item?.id ?? '',
    first_name: item?.first_name ?? '',
    last_name: item?.last_name ?? '',
    workspaces_id: getWorkspaceId(item),
    workspaces_name: getWorkspaceName(item),
    role_id: item?.role_id ?? '',
    role_name: getRoleName(item),
    count_qualifications: item?.count_qualifications ?? item?.qualifications_count ?? '',
    deposits_count: item?.deposits_count ?? '',
    deposits_amount: item?.deposits_amount ?? '',
    players_avg_amount: item?.players_avg_amount ?? '',
    is_ban: item?.is_ban ?? '',
    ban_date: item?.ban_date ?? '',
    is_verified: item?.is_verified ?? '',
    verify_date: item?.verify_date ?? '',
    created_at: formatDateForExport(item?.created_at),
    wallet_created_at: formatDateForExport(item?.wallet_created_at),
    wallet_currency: item?.wallet_currency ?? '',
    wallet_details: item?.wallet_details ?? '',
    wallet_id: item?.wallet_id ?? '',
    wallet_type: item?.wallet_type ?? '',
  };
};

const getWorkspaceOptions = (items) => {
  const options = (items || [])
    .map((item) => {
      const workspace = item?.workspace || item?.workspaces;
      const id = getWorkspaceId(item) || workspace?.id;
      const name = getWorkspaceName(item) || workspace?.name;
      return {
        value: id,
        label: name ? `#${id} ${name}` : `#${id}`,
      };
    })
    .filter((item) => item.value);

  return options.filter((item, index, array) => {
    return array.findIndex((option) => option.value === item.value) === index;
  });
};

const filterBySelectedWorkspaces = (items, selectedWorkspaces) => {
  const selectedIds = selectedWorkspaces.map((item) => String(item.value));
  if (!selectedIds.length) return items;

  return items.filter((item) => selectedIds.includes(String(getWorkspaceId(item))));
};

const TOPLTCWrapper = () => {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [time, setTime] = useState({});

  return (
    <PageWrapper
      firstTimeConfig='week_sales_periods'
      breadcrumbs={[
        {title: 'Отдел продаж'},
        {isSeparator: true},
        {title: 'Рейтинг RD', path: '/sales/rd/top/managers', isActive: true},
      ]}
      buttonKPI={
        roles.includes(4) ||
        roles.includes(8) ||
        roles.includes(30) ||
        roles.includes(13) ||
        roles.includes(32) ? (
          <ButtonExel
            data={data}
            fieldsToKeep={TOP_EXPORT_FIELDS}
            columnFormats={{deposits_amount: '$#,##0.00', players_avg_amount: '$#,##0.00'}}
            fileName={'rating_rd_managers'}
            time={time}
          />
        ) : (
          <></>
        )
      }
      title={'Рейтинг RD'}
    >
      <TOPRD setObjForExel={setData} setRoles={setRoles} setTimeForExel={setTime} />
    </PageWrapper>
  );
};

const TOPRD = observer(
  ({isVerify, timeConfig, setPreloader, setObjForExel, setTimeForExel, setRoles}) => {
    const store = useStore();
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [footerData, setFooterData] = useState([]);
    const [workspaceOptions, setWorkspaceOptions] = useState([]);
    const [selectedWorkspaces, setSelectedWorkspaces] = useState([]);

    useEffect(() => {
      setObjForExel(null);
      setRoles(store.roles);
      isVerify && getData();
    }, [isVerify, timeConfig]);

    useEffect(() => {
      applyWorkspaceFilter(allData);
    }, [selectedWorkspaces]);

    const getTopParams = () => {
      const baseParams =
        timeConfig.time_config === 'week_sales_periods'
          ? {time_config: '', time_start: '', time_end: ''}
          : timeConfig;

      return baseParams;
    };

    const applyWorkspaceFilter = (sourceList) => {
      const filteredList = filterBySelectedWorkspaces(sourceList, selectedWorkspaces);

      setObjForExel(filteredList.map(createExportRow));
      setData(filteredList);

      const newFooterData = filteredList.filter((item) => item.place !== 99999);
      setFooterData(newFooterData);
    };

    const getData = async () => {
      const [result, rdCategories] = await Promise.all([
        store.requestGet('Sales/Rd/Managers/getTop', {
          params: getTopParams(),
          returnFullObj: true,
        }),
        store.requestGet(`Finance/Category/getRdList`),
      ]);

      const rows = Array.isArray(result?.data) ? result.data : result || [];

      setWorkspaceOptions((prevOptions) => {
        const nextOptions = [...prevOptions, ...getWorkspaceOptions(rows)];
        return nextOptions.filter((item, index, array) => {
          return array.findIndex((option) => option.value === item.value) === index;
        });
      });

      const preparedList = rows.map((item) => {
          const countQualifications = getNumberValue(item?.qualifications_count);
          const countDeposits = getNumberValue(item?.deposits_count);
          const amountsDeposits = getNumberValue(item?.deposits_amount);
          const averageCheck = getNumberValue(item?.players_avg_amount);
          const originalPlace = getNumberValue(item?.place);
          const isTopEligible = amountsDeposits >= MIN_DEPOSIT_AMOUNT_FOR_TOP;

          return {
            ...item,
            full_name: `${item.first_name} ${item.last_name}`,
            qualifications_count: countQualifications,
            deposits_count: countDeposits,
            deposits_amount: amountsDeposits,
            players_avg_amount: averageCheck,
            players_count: getNumberValue(item?.players_count),
            status: {
              indicator: isTopEligible ? getRdStatus(rdCategories, averageCheck) : 'secondary',
            },
            place: originalPlace > 0 && isTopEligible ? originalPlace : 99999,
            is_top_eligible: isTopEligible,
          };
        });

      const hasBackendPlaces = preparedList.some((item) => item.place !== 99999);

      const eligibleList = preparedList
        .filter((item) => item.is_top_eligible)
        .sort((a, b) => {
          if (hasBackendPlaces) return a.place - b.place;
          return b.players_avg_amount - a.players_avg_amount;
        })
        .map((item, index) => ({
          ...item,
          place: hasBackendPlaces ? item.place : index + 1,
        }));

      const newList = [
        ...eligibleList,
        ...preparedList
          .filter((item) => !item.is_top_eligible)
          .sort((a, b) => b.deposits_amount - a.deposits_amount),
      ];

      setTimeForExel(result.time);
      setAllData(newList);
      applyWorkspaceFilter(newList);
      setPreloader(false);
    };

    const headerData = [
      ...footerData,
      ...data.filter((item) => !footerData.some((footerItem) => footerItem.id === item.id)),
    ];

    return (
      <>
        <Header top_1={headerData[0]} top_2={headerData[1]} top_3={headerData[2]} />
        <List
          data={data}
          withoutOutsiders={footerData}
          workspaceOptions={workspaceOptions}
          selectedWorkspaces={selectedWorkspaces}
          setSelectedWorkspaces={setSelectedWorkspaces}
        />
        <Footer
          data={footerData.slice(footerData.length - 3, footerData.length)}
          length={footerData.length - 2}
        />
      </>
    );
  }
);

export default TOPLTCWrapper;
